export default "__VITE_ASSET__D3U76sx3__"